import { useState } from "react";
import Modal from "../../../../components/common/modal/Modal";
import ButtonComponent from "../../../../components/common/button/Button";


export const SendToS4Modal = ({ disabledSendToS4Button, onClickSendToS4Handler, setBulkPDTDisabled, setBulkPDTValue }) => {

    const [openSendToS4Modal, setOpenSendToS4Modal] = useState(false);

    const onClickSendToS4Button = () => {
        setOpenSendToS4Modal(true);
    };
    const closeSendToS4Modal = () => {
        setOpenSendToS4Modal(false);
    };

    const onClickSubmitSendToS4 =()=>{
        setOpenSendToS4Modal(false);
        onClickSendToS4Handler();
        setBulkPDTDisabled(true);
        setBulkPDTValue("");
    }

    return (
        <>
            <ButtonComponent
                maxWidth="230px"
                label="Approve & Send To S/4"
                bgColor="black"
                color="white"
                onClick={onClickSendToS4Button}
                disabled={disabledSendToS4Button}
            />
            <Modal
                className="sendToS4_Modal_cls"
                open={openSendToS4Modal}
                handleClose={closeSendToS4Modal}
                title="Send To S/4"
                action={
                    <SendToS4WorkFlowFooter
                    closeSendToS4Modal={closeSendToS4Modal}
                    onClickSubmitSendToS4={onClickSubmitSendToS4}
                />
                }
                content={
                    <SendToS4WorkFlowContent />
                }
                maxWidth="100px"
            />

        </>
    )
}

const SendToS4WorkFlowFooter = ({ closeSendToS4Modal, onClickSubmitSendToS4 }) => {

    return (
        <div className='footer-btn-wrapper sendToS4WorkFlowFooter'>
            <ButtonComponent
                maxWidth="170px"
                label={"Cancel"}
                type="primary"
                onClick={closeSendToS4Modal}
            />
            <ButtonComponent
                maxWidth="170px"
                label={"OK"}
                bgColor="black"
                color="white"
                onClick={onClickSubmitSendToS4}
            />
        </div>
    );
};
const SendToS4WorkFlowContent = () => {

    return (
        <div className='sendToS4WorkFlowContent'>
           <p>Warning - you are Sending to S4 for all the selected line item</p>
        </div>
    );
};